import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "../../Assets/images/logo.png";
import { useLoginModal } from "../../App/LoginModalProvider";
import {
  createOrder,
  getCategoryList,
  toastError,
  toastSuccess,
} from "../../api/services";
import {
  removeFromCart,
  selectCartItems,
  selectCartTotalAmount,
  selectOriginalTotal,
  selectTotalDiscount,
  setTabCarted,
  updateQuantity,
} from "../../Features/Cart/cartSlice";
import { MdOutlineClose } from "react-icons/md";
import useAuth from "../../Features/Utils/useAuth";
import MyAccountDropdown from "./MyAccountDropdown";
import SearchBar from "./SearchBar";

const Navbar = () => {
  const { isAuthenticated, user, logout } = useAuth();

  const [loading, setLoading] = useState(false);
  const cartItemsHeader = useSelector(selectCartItems);
  const totalAmount = useSelector(selectCartTotalAmount);
  const totalDiscount = useSelector(selectTotalDiscount);
  const originalTotal = useSelector(selectOriginalTotal);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const totalPrice = useSelector(selectCartTotalAmount);
  const dispatch = useDispatch();
  const { openLoginModal } = useLoginModal();
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  // Load categories on mount
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await getCategoryList();
        setCategories(res?.data?.data || []);
      } catch (err) {
        console.error("Category error:", err);
      }
    };
    loadCategories();
  }, []);

  // Toggle mobile menu with body scroll lock
  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => {
      const newState = !prev;
      document.body.style.overflow = newState ? "hidden" : "auto";
      return newState;
    });
  };

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
    document.body.style.overflow = "auto";
  }, [location]);

  // Handle quantity change in cart popup
  const handleQuantityChange = (productId, variantID, quantity) => {
    if (quantity >= 1 && quantity <= 20) {
      dispatch(
        updateQuantity({
          productID: productId,
          variantID: variantID,
          quantity: quantity,
        }),
      );
    }
  };

  const handleCreateOrder = async () => {
    try {
      setLoading(true);
      debugger;
      const payload = {
        userId: user?.id,
        amount: totalPrice,
        totalAmount: totalAmount,
        totalDiscount: totalDiscount,
        originalTotal: originalTotal,
        discount: 0,
        platformFee: 7,
        paymentMethod: "cod",
        items: cartItemsHeader,
      };

      const res = await createOrder(payload);
      if (res?.data?.success) {
        toastSuccess("Order Created: " + res?.data?.data?.orderId);
        navigate("/checkout");
      } else {
        toastError("❌ " + res.message);
      }
    } catch (error) {
      console.error(error);

      // ✅ Proper error handling
      if (error.response) {
        toastSuccess("❌ " + error.response.data.message);
      } else {
        toastError("❌ Network Error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="navbar__wrapper">
      {/* TOP BAR */}
      <div className="top_bar theme_bg">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-12 col-md-12">
              <div className="top_bar_right_links d-flex justify-content-end py-2 top-header-border">
                <ul className="top_bar_links d-flex">
                  <li>
                    <a href="mailto:info@nevaana.com">
                      Email : info@nevaana.com
                    </a>
                  </li>
                  <li>
                    <a href="tel:9012121202">Support : 9012121202</a>
                  </li>
                  <li>
                    <Link to="/vendor-register">Sell On nevaana.com</Link>
                  </li>
                  <li>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.covicure"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download App
                    </a>
                  </li>
                </ul>
                <div id="google_translate_element"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* LOGO BAR */}
      <div className="logo_bar theme_bg_light py-3 second-header-two">
        <div className="container d-flex justify-content-between align-items-center">
          {/* LOGO */}
          <div className="brand-logo">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </div>

          {/* SEARCH */}
          <div className="top_search search-input2">
            <div className="header-search">
              <SearchBar />
            </div>
          </div>

          {/* RIGHT ICONS */}
          <div className="logo_lists logo-lists-two">
            <ul className="d-flex align-items-center">
              {isAuthenticated ? (
                <MyAccountDropdown user={user} logout={logout} />
              ) : (
                <li className="my-account">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      openLoginModal();
                    }}
                  >
                    <i className="far fa-user-circle"></i>
                    <span>
                      <div className="hello">Hello!</div>
                      <div>My Account</div>
                    </span>
                  </Link>
                </li>
              )}

              {/* CART ICON WITH POPUP */}
              <li className="shopping-bag">
                <button
                  className="foodButton"
                  onClick={() => {
                    dispatch(setTabCarted("cartTab1"));
                    navigate("/cart");
                  }}
                >
                  <i className="fas fa-shopping-bag foodButtonIcon"></i>
                  <div className="cart-count">
                    {cartItemsHeader?.length || 0}
                  </div>
                </button>

                <div className="shopping-popup">
                  {cartItemsHeader.length > 0 ? (
                    <div className="shopping-popup-food">
                      {cartItemsHeader.map((item, index) => (
                        <div key={`${item.productID}-${index}`}>
                          <div className="shoppingBagTableMobileItemsFood">
                            <div className="shoppingBagTableMobileItemsImgFood">
                              <Link to={`/product/${item.slug}`}>
                                <img
                                  src={item.frontImg}
                                  alt={item.productName}
                                />
                              </Link>
                            </div>
                            <div className="shoppingBagTableMobileItemsDetail">
                              <div className="shoppingBagTableMobileItemsDetailMain">
                                <Link to={`/product/${item.slug}`}>
                                  <h4>{item.productName}</h4>
                                </Link>
                                <div className="shoppingMobileQuantityFood">
                                  <div className="shoppingBagTableMobileQuantityFood">
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item.productID,
                                          item.variantID,
                                          item.quantity - 1,
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <input
                                      type="text"
                                      min="1"
                                      max="20"
                                      value={item.quantity}
                                      onChange={(e) =>
                                        handleQuantityChange(
                                          item.productID,
                                          item.variantID,
                                          Number.parseInt(e.target.value, 10) ||
                                            1,
                                        )
                                      }
                                    />
                                    <button
                                      onClick={() =>
                                        handleQuantityChange(
                                          item.productID,
                                          item.variantID,
                                          item.quantity + 1,
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>
                                  <span>₹{item.productPrice}</span>
                                </div>
                              </div>
                              <div className="shoppingBagTableMobileItemsDetailTotalFood">
                                <MdOutlineClose
                                  size={20}
                                  onClick={() => dispatch(removeFromCart(item))}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <ul>
                      <li>No Items In Cart</li>
                    </ul>
                  )}
                  <div className="view-cart border-0">
                    <h6>
                      SUBTOTAL{" "}
                      <span className="float-right">
                        ₹{totalPrice.toFixed(2)}
                      </span>
                    </h6>
                  </div>

                  <div className="view-cart border-0">
                    {isAuthenticated ? (
                      <button
                        className="btn btn-danger"
                        onClick={handleCreateOrder}
                        disabled={loading}
                      >
                        {loading ? (
                          <span className="spinner"></span>
                        ) : (
                          "CHECKOUT"
                        )}
                      </button>
                    ) : (
                      <button
                        className="btn btn-block checkout"
                        onClick={() => {
                          openLoginModal();
                        }}
                      >
                        CHECKOUT
                      </button>
                    )}
                  </div>
                </div>
              </li>

              {/* MOBILE MENU TOGGLE */}
              <li className="compareing mobile_search-Mobile">
                <Link to="#" onClick={(e) => { e.preventDefault(); toggleMobileMenu(); }}>
                  <i className="fas fa-list"></i>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* NAVIGATION MENU (DESKTOP + MOBILE) */}
      <nav className="navbar navbar-expand-lg" id="mainNav">
        <div className="container">
          <div
            className={`collapse navbar-collapse ${mobileMenuOpen ? "show" : ""}`}
          >
            <ul className="navbar-nav mx-auto w-100 justify-content-between nav_menu_item">
              {categories && categories.length > 0 ? (
                categories.map((cat) => (
                  <li key={cat.id} className="nav-item">
                    <Link to={`/category/${cat.slug}`} className="nav-link">
                      {cat.name}
                    </Link>
                  </li>
                ))
              ) : (
                <li className="nav-item">
                  <span className="nav-link">Loading categories...</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>

      {/* MOBILE SEARCH BAR (visible only on small screens) */}
      <div className="mobile_search search-input2">
        <div className="header-search">
          <SearchBar />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
